import React, { useEffect, useState } from "react";
import { Field } from "formik";
import { makeStyles } from "@material-ui/core/styles";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import toastError from "../../errors/toastError";
import api from "../../services/api";
import { i18n } from "../../translate/i18n";
import Typography from "@material-ui/core/Typography";

const useStyles = makeStyles(theme => ({
    wrapper: {
        marginTop: theme.spacing(1),
    },
    formControl: {
        minWidth: 120,
        "& .MuiOutlinedInput-root": {
            borderRadius: 8,
            backgroundColor: theme.mode === "light" ? "#ffffff" : "#343434",
            color: theme.mode === "light" ? "#172033" : "#f8fafc",
            "& fieldset": {
                borderColor: theme.mode === "light" ? "#d7e1ee" : "rgba(255,255,255,0.12)",
            },
            "&:hover fieldset": {
                borderColor: theme.mode === "light" ? "#c6d4e6" : "rgba(255,255,255,0.20)",
            },
            "&.Mui-focused fieldset": {
                borderColor: theme.palette.primary.main,
                borderWidth: 1,
                boxShadow: theme.mode === "light" ? "0 0 0 3px rgba(93, 170, 252, 0.12)" : "0 0 0 3px rgba(93, 170, 252, 0.14)",
            },
        },
        "& .MuiSelect-icon": {
            color: theme.mode === "light" ? "#64748b" : "#dbeafe",
        },
    },
    label: {
        marginBottom: theme.spacing(0.75),
        fontSize: 12,
        fontWeight: 800,
        textTransform: "uppercase",
        letterSpacing: 0.2,
        color: theme.mode === "light" ? "#315b8f" : "#9ccaef",
    },
}));

const QueueSelectSingle = () => {
    const classes = useStyles();
    const [queues, setQueues] = useState([]);

    useEffect(() => {
        (async () => {
            try {
                const { data } = await api.get("/queue");
                setQueues(data);
            } catch (err) {
                toastError(`QUEUESELETSINGLE >>> ${err}`);
            }
        })();
    }, []);

    return (
        <div className={classes.wrapper}>
            <FormControl
                variant="outlined"
                className={classes.formControl}
                margin="dense"
                fullWidth
            >
                <div>
                    <Typography className={classes.label}>
                        {i18n.t("queueSelect.inputLabel")}
                    </Typography>
                    <Field
                        as={Select}
                        label={i18n.t("queueSelect.inputLabel")}
                        name="queueId"
                        labelId="queue-selection-label"
                        id="queue-selection"
                        variant="outlined"
                        fullWidth
                    >
                        <MenuItem value="">
                            {i18n.t("queueSelect.withoutQueue")}
                        </MenuItem>
                        {queues.map(queue => (
                            <MenuItem key={queue.id} value={queue.id}>
                                {queue.name}
                            </MenuItem>
                        ))}
                    </Field>
                </div>
            </FormControl>
        </div>
    );
};

export default QueueSelectSingle;
